module.exports = require("warning");


//////////////////
// WEBPACK FOOTER
// external "warning"
// module id = 20
// module chunks = 0